import translate from "components/translations/translations.wrapper";
import { CircleQuestionMark } from "lucide-react";
import { ICON_SIZE } from "components/common/constants";

export const LinkToHelpCenter = ({ translate }) => {
    const helpCenterReplacementUrl = window.ENVIRONMENT?.HELP_CENTER_URL;
    return (
        <li className="icon" title={translate("menu.helpBoxReplacement.label")}>
            <a className="button-help" target="tab-helpcenter" rel="noopener noreferrer" aria-label={translate("menu.helpBoxReplacement.label")} href={helpCenterReplacementUrl}>
                <CircleQuestionMark size={ICON_SIZE.MEDIUM} aria-hidden="true" />
                <span className="notificationBadge badge" />
            </a>
        </li>
    );
};

export default translate(LinkToHelpCenter);